<template>
  <b-navbar
    class="navbar"
    fixed="top"
    toggleable="lg"
    style="display: flex; justify-content: space-between"
    sticky
  >
    <div style="display: flex">
      <div class="menu-btn" @click="toggleMenu()">
        <div class="menu-btn__burger" />
      </div>
      <div style="margin: 10px 0 0 15px; height: 60px; overflow: hidden">
        <a href="/">
          <img
            class="img"
            src="../assets/Final Logo Transparent 2.svg"
            style="
              object-fit: contain;
              width: 300px;
              height: 200px;
              object-position: left center;
              margin: -60px -80px -120px 0;
            "
          />
        </a>
      </div>
    </div>
    <b-row>
      <div style="margin-right: 20px; font-size: 24px">
        <a
          href="mailto:datamaestrofeedback@revelwood.com?subject=Feedback%20for%20DataMaestro"
          target="_blank"
          style="color: #b3282d"
        >
          <el-tooltip placement="bottom">
            <span slot="content">Send Feedback</span>
            <i class="el-icon-s-comment" />
          </el-tooltip>
        </a>
      </div>
      <div style="margin-right: 40px; font-size: 24px">
        <a
          href="https://dm-knowledgebase.revelwood.com/"
          target="_blank"
          style="color: #b3282d"
        >
          <el-tooltip placement="bottom">
            <span slot="content">Knowledge Base</span>
            <i class="el-icon-question" />
          </el-tooltip>
        </a>
      </div>
      <div v-if="instanceId" style="margin-right: 20px">
        <div class="profile">
          <i class="el-icon-s-platform" />
          {{ envName }}
        </div>
        <div class="profile">
          <i class="el-icon-menu" />
          {{ currentServer }}
        </div>
      </div>
      <div v-if="isUserLoggedIn" style="margin-right: 40px">
        <div class="profile">
          <i class="el-icon-office-building" />
          {{ organizationName }}
        </div>
        <div class="profile">
          <i class="el-icon-user-solid" />
          {{ email }}
        </div>
      </div>
    </b-row>
  </b-navbar>
</template>

<script>
import { mapState } from "vuex";
import EventBus from "../services/EventBus";
import AdministrationService from "../services/AdministrationService";

/**
 * @vue-computed {Helper} mapState - Maps Vuex state to computed properties
 */
export default {
  name: "PageHeader",
  computed: {
    ...mapState([
      "instanceId",
      "environmentId",
      "userId",
      "userRole",
      "isUserLoggedIn",
      "envName",
      "currentServer",
    ]),
  },
  watch: {
    isUserLoggedIn() {
      this.getUserInfo();
    },
  },
  data() {
    return {
      isCollapse: true,
      menuOpen: false,
      email: null,
      organizationName: null,
    };
  },
  methods: {
    toggleMenu() {
      EventBus.$emit("toggleMenu");
      if (!this.menuOpen) {
        document.querySelector(".menu-btn").classList.add("open");
      } else {
        document.querySelector(".menu-btn").classList.remove("open");
      }
      this.menuOpen = !this.menuOpen;
    },
    async getUserInfo() {
      if (!this.userId) return;

      try {
        const response = await AdministrationService.getUserInfo({
          userId: this.userId,
        });
        this.email = response.data.email;
        this.organizationName = response.data.organizationName;
      } catch (err) {
        this.$message({
          type: "warning",
          message: err.response ? err.response.data.error : err,
          duration: 7000,
          showClose: true,
        });
      }
    },
  },
  mounted() {
    this.getUserInfo();
  },
};
</script>
<style scoped>
.profile {
  font-size: 14px;
}
.navbar {
  height: 10vh;
  background-color: #f0f0f0;
  border-bottom: 2px solid #909399;
}
.img {
  height: auto;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.menu-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  width: 70px;
  height: 70px;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
}
.menu-btn__burger {
  width: 35px;
  height: 4px;
  background: #b3282d;
  border-radius: 4px;
  transition: all 0.5s ease-in-out;
}
.menu-btn__burger::before,
.menu-btn__burger::after {
  content: "";
  position: absolute;
  width: 35px;
  height: 4px;
  background: #b3282d;
  border-radius: 4px;
  transition: all 0.5s ease-in-out;
}
.menu-btn__burger::before {
  transform: translateY(-11px);
}
.menu-btn__burger::after {
  transform: translateY(11px);
}
/* ANIMATION */
.menu-btn.open .menu-btn__burger {
  transform: translateX(-50px);
  background: transparent;
}
.menu-btn.open .menu-btn__burger::before {
  transform: rotate(45deg) translate(35px, -35px);
}
.menu-btn.open .menu-btn__burger::after {
  transform: rotate(-45deg) translate(35px, 35px);
}
</style>
